import Axios from "axios";
import {
    SET_PUR_ORDER_LIST,
    UNSET_PUR_ORDER_LIST,
    SET_RECEIVABLE_PUR_ORDER_LIST,
    UNSET_RECEIVABLE_PUR_ORDER_LIST,
  } from "@/store/mutation-types";
import {saveUpdatePurOrder,
   getPurOrderList,
   getPurOrderById as getPurOrderByIdApi,
   getReceivablePurchaseOrderList,
   getCsEvaluationByPoId as getCsEvaluationByPoIdApi
  } from "@/store/api";
// initial state
const state = {
  getPurOrderList: [],
  editingPurOrder: null,
};

const getters = {
  getPurOrderList(state) {
    return state.getPurOrderList;
  },
  getReceivablePurchaseOrderList(state) {
    return state.getReceivablePurchaseOrderList;
  },
};

const mutations = {
  [SET_PUR_ORDER_LIST](state, data) {
    state.getPurOrderList = data;
  },
  [UNSET_PUR_ORDER_LIST](state) {
    state.getPurOrderList = [];
  },
  setEditingPrOrder(state, requisition) {
    state.editingPurOrder = requisition;
  },
  [SET_RECEIVABLE_PUR_ORDER_LIST](state, data) {
    state.getReceivablePurchaseOrderList = data;
  },
  [UNSET_RECEIVABLE_PUR_ORDER_LIST](state) {
    state.getReceivablePurchaseOrderList = [];
  },
};

const actions = {
  getReceivablePurchaseOrderList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(getReceivablePurchaseOrderList, { data })
        .then(function (response) {
          commit('SET_RECEIVABLE_PUR_ORDER_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_RECEIVABLE_PUR_ORDER_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },
  saveUpdatePurOrder({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdatePurOrder, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {

          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  getPurOrderList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(getPurOrderList, data)
        .then(function (response) {
          commit('SET_PUR_ORDER_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_PUR_ORDER_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },

  getPurOrderById({ commit }, id) {
    const getPurOrderById = `${getPurOrderByIdApi}/${id}`;
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(getPurOrderById)
        .then((response) => {
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        })
        .then((always) => {
          commit("UNSET_LOADING");
        });
    });
  },

  getCsEvaluationByPoId({ commit }, id) {
    const getCsEvaluationByPoId = `${getCsEvaluationByPoIdApi}/${id}`;
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.get(getCsEvaluationByPoId)
        .then((response) => {
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        })
        .then((always) => {
          commit("UNSET_LOADING");
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
